import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../shared/Icon';
import i18n from '../../i18n';

// `label` is a lazy i18n getter (see docs/I18N.md "Shared label modules") so
// SettingsModal.js keeps reading `.label`/`activeSection.label` with zero
// changes while the value resolves at render time instead of module load.
export const SETTINGS_TABS = [
  { id: 'profile', get label() { return i18n.t('settings:tabNavigation.tabs.profile'); }, icon: 'user', iconColor: 'text-primary' },
  { id: 'privacy', get label() { return i18n.t('settings:tabNavigation.tabs.privacy'); }, icon: 'lock', iconColor: 'text-info' },
  { id: 'groups', get label() { return i18n.t('settings:tabNavigation.tabs.groups'); }, icon: 'userGroup', iconColor: 'text-success' },
  { id: 'children', get label() { return i18n.t('settings:tabNavigation.tabs.children'); }, icon: 'baby', iconColor: 'text-tour' },
  { id: 'passports', get label() { return i18n.t('settings:tabNavigation.tabs.passports'); }, icon: 'document', iconColor: 'text-accent-dark' },
  { id: 'preferences', get label() { return i18n.t('settings:tabNavigation.tabs.preferences'); }, icon: 'shield', iconColor: 'text-warning' },
  { id: 'help', get label() { return i18n.t('settings:tabNavigation.tabs.help'); }, icon: 'question', iconColor: 'text-primary-light' }
];

// Tab strip — desktop only. Mobile uses a list-of-rows pattern rendered in SettingsModal.
function TabNavigation({ activeTab, setActiveTab }) {
  const { t } = useTranslation('settings');
  return (
    <div className="hidden sm:flex justify-center overflow-x-auto">
      <div className="bg-background rounded-lg p-1 flex flex-wrap justify-center gap-1" role="tablist" aria-label={t('tabNavigation.ariaLabel')}>
        {SETTINGS_TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`${tab.id}-panel`}
            data-tour={`settings-tab-${tab.id}`}
            className={`px-6 py-2 rounded-lg font-medium transition-all duration-fast focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ${
              activeTab === tab.id
                ? 'bg-primary-lighter text-primary shadow-card'
                : 'text-content-secondary hover:text-content-primary hover:bg-surface active:scale-[0.98]'
            }`}
          >
            <span className="inline-flex items-center gap-1.5"><Icon name={tab.icon} className="w-4 h-4" /> {tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default TabNavigation;
